import { useEffect, useState } from "react";

import { getSupaClient } from "../../lib/supabase";
import { BillingStatus, BillingTier } from "@prisma/client";

/*
 * Hook to fetch stripe data about a given customer.
 *
 */
function useStripeCustomers(guildId: string | null) {
  const [billingCustomer, setBillingCustomer] = useState<{
    stripe_id: string;
    status: BillingStatus;
    tier: BillingTier;
    email: string;
    trial_end: string;
    trial_tier: BillingTier;
  }>();

  const [loading, setLoading] = useState<boolean>(true);
  const supabase = getSupaClient();

  /**
   * Pulls info on the billling customer based on our internal billing iD
   */

  const pullStripeCustomer = async (billingId: string) => {
    const { data, error } = await supabase
      .from("stripe_users")
      .select("stripe_id, status, tier, email, trial_end, trial_tier")
      .eq("id", billingId);
    if (data) {
      setBillingCustomer(data[0]);
    }
    if (error) {
      console.log("Error in getting stripe user", error);
    }
  };

  /**
   * Pulls customer id for a given guild
   */
  const pullCustomerId = async () => {
    try {
      const { data, error } = await supabase
        .from("discord_guilds")
        .select("discord_id, stripe_user_id")
        .eq("discord_id", guildId);
      if (data) {
        await pullStripeCustomer(data[0]?.stripe_user_id);
      }
      if (error) {
        console.log("Error in getting stripe user", error);
      }
    } finally {
      setLoading(false);
    }
  };

  /**
   * useEffect to pull stripe data
   */
  useEffect(() => {
    setLoading(true);
    pullCustomerId();
  }, []);

  return {
    isLoading: loading,
    billingCustomer,
  };
}

export default useStripeCustomers;
